export interface InviteStatusParams {
  isPromotionLoading: boolean
  isPromotionError: boolean
  qrCodeError: boolean
  hasQrCode: boolean
  hasPoster: boolean
}

/**
 * 纯逻辑：计算邀请页面按钮是否应当禁用
 */
export function computeInviteButtonsDisabled(
  params: InviteStatusParams,
): boolean {
  if (params.isPromotionLoading) return true
  if (params.isPromotionError) return true
  if (params.qrCodeError) return true
  if (!params.hasQrCode) return true
  if (!params.hasPoster) return true
  return false
}
